module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass
  }, [(_vm.$scopedSlots.header) ? _c('div', {
    staticClass: "p-dataview-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), (_vm.paginatorTop) ? _c('DVPaginator', {
    class: {
      'p-paginator-top': _vm.paginatorTop
    },
    attrs: {
      "rows": _vm.d_rows,
      "first": _vm.d_first,
      "totalRecords": _vm.getTotalRecords,
      "pageLinkSize": _vm.pageLinkSize,
      "template": _vm.paginatorTemplate,
      "rowsPerPageOptions": _vm.rowsPerPageOptions,
      "currentPageReportTemplate": _vm.currentPageReportTemplate,
      "alwaysShow": _vm.alwaysShowPaginator
    },
    on: {
      "page": function($event) {
        return _vm.onPage($event)
      }
    },
    scopedSlots: _vm._u([(_vm.$scopedSlots.paginatorLeft) ? {
      key: "left",
      fn: function() {
        return [_vm._t("paginatorLeft")]
      },
      proxy: true
    } : null, (_vm.$scopedSlots.paginatorRight) ? {
      key: "right",
      fn: function() {
        return [_vm._t("paginatorRight")]
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-dataview-content"
  }, [_c('div', {
    staticClass: "p-grid p-nogutter grid grid-nogutter"
  }, [_vm._l((_vm.items), function(item, index) {
    return [(_vm.$scopedSlots.list && _vm.layout === 'list') ? _vm._t("list", null, {
      "data": item,
      "index": index
    }) : _vm._e(), _vm._v(" "), (_vm.$scopedSlots.grid && _vm.layout === 'grid') ? _vm._t("grid", null, {
      "data": item,
      "index": index
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.empty) ? _c('div', {
    staticClass: "p-col col"
  }, [_c('div', {
    staticClass: "p-dataview-emptymessage"
  }, [_vm._t("empty")], 2)]) : _vm._e()], 2)]), _vm._v(" "), (_vm.paginatorBottom) ? _c('DVPaginator', {
    class: {
      'p-paginator-bottom': _vm.paginatorBottom
    },
    attrs: {
      "rows": _vm.d_rows,
      "first": _vm.d_first,
      "totalRecords": _vm.getTotalRecords,
      "pageLinkSize": _vm.pageLinkSize,
      "template": _vm.paginatorTemplate,
      "rowsPerPageOptions": _vm.rowsPerPageOptions,
      "currentPageReportTemplate": _vm.currentPageReportTemplate,
      "alwaysShow": _vm.alwaysShowPaginator
    },
    on: {
      "page": function($event) {
        return _vm.onPage($event)
      }
    },
    scopedSlots: _vm._u([(_vm.$scopedSlots.paginatorLeft) ? {
      key: "left",
      fn: function() {
        return [_vm._t("paginatorLeft")]
      },
      proxy: true
    } : null, (_vm.$scopedSlots.paginatorRight) ? {
      key: "right",
      fn: function() {
        return [_vm._t("paginatorRight")]
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e(), _vm._v(" "), (_vm.$scopedSlots.footer) ? _c('div', {
    staticClass: "p-dataview-footer"
  }, [_vm._t("footer")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0019a466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/dataview/DataView.vue
// module id = 1999
// module chunks = 0